export default __webpack_public_path__ + "static/media/AllrfpLightActive.70a9e55a.svg";